import React, { FC } from 'react';
import { Asset } from '../../../api';
import '../styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getAllInProgress, getAssetsInPack, getInProgress } from '../selectors';
import * as packActions from '../actions';
import { Button, Checkbox } from '@myua/kit';
import { getAssetLabLogger } from '../../app/logs';
import { getPermissions } from '../../app/selectors';
import { Permission } from '../../../../general/model';

const stopPropagation: React.HTMLAttributes<HTMLDivElement>['onClick'] = (e) => e.stopPropagation();

export const PackToggle: FC<{ asset: Asset }> = ({ asset }) => {
  const dispatch = useDispatch();
  const inPack = useSelector(getAssetsInPack)[asset.id];
  const allInProgress = useSelector(getAllInProgress);
  const inProgress = useSelector(getInProgress);
  const assetLabLogger = useSelector(getAssetLabLogger);

  const permissions = useSelector(getPermissions);
  if (!permissions[Permission['fs.assetlab_packs']]) {
    return null;
  }

  // Если данный ассет уже в обработке или если все ассеты в обработке, то не позволяем нажимать кнопку.
  const disabled = allInProgress || inProgress[asset.id];

  return (
    <div className="al-pack-toggle" onClick={stopPropagation}>
      <Checkbox
        disabled={disabled}
        checked={inPack}
        onChange={() => {
          const add = !inPack;
          const assets = [asset];
          dispatch(packActions.assetsToggled({ add, assets }));
          assetLabLogger({
            action: 'Pack',
            sub_action: 'Toggle',
            extra: {
              // asset_ids: assets.map(({ id }) => id),
              bool_1: add,
              text_1: 'single',
            },
          });
        }}
      />
    </div>
  );
};

export const PackToggleMultiple: FC<{ assets: Asset[] }> = ({ assets }) => {
  const dispatch = useDispatch();
  const inProgress = useSelector(getInProgress);
  const allInProgress = useSelector(getAllInProgress);
  const assetsInPack = useSelector(getAssetsInPack);
  const assetLabLogger = useSelector(getAssetLabLogger);

  const permissions = useSelector(getPermissions);
  if (!permissions[Permission['fs.assetlab_packs']]) {
    return null;
  }

  // Если хотя бы один ассет уже в обработке, то не позволяем нажимать кнопку.
  // Блокируем ее, а не ставим loading, чтобы спиннер не смущал юзера, т.к. не все выбранные
  // ассеты могут находиться в обработке.
  const disabled = allInProgress || assets.some(({ id }) => inProgress[id]);

  const selectAll = assets.length === 0;
  const add = selectAll
    ? // Если находимся в режиме обработки сразу всех ассетов, то мы не знаем, все ли они уже в паке или нет,
      // поэтому предлагаем добавить их в пак.
      true
    : // Если хотя бы один из выбранных ассетов не добавлен, то предлагаем добавить
      // все выбранные ассеты. Иначе предлагаем удалить все выбранные ассеты.
      assets.some(({ id }) => !assetsInPack[id]);

  return (
    <Button
      disabled={disabled}
      onClick={() => {
        dispatch(packActions.assetsToggled({ add, assets, selectAll }));
        assetLabLogger({
          action: 'Pack',
          sub_action: 'Toggle',
          extra: {
            // asset_ids: assets.map(({ id }) => id),
            bool_1: add,
            text_1: selectAll ? 'all' : 'multiple',
          },
        });
      }}
    >
      {add ? 'Add to pack' : 'Remove from pack'}
    </Button>
  );
};
